import { useNavigate } from 'react-router-dom';
interface Props {
    data: ProjectDataT
    externalLink?: boolean
}


export default function CardImage({ data, externalLink }: Props) {
    const { description, project_Name, image_Url, project_url } = data;

    const navigate = useNavigate();

    const location = window.location;

    const ctaLabel = <span>Learn<br />More</span>;
    const cta = externalLink
        ? (<a className="card-image__cta" href={project_url} target="_blank" rel="noopener noreferrer">{ctaLabel}</a>)
        : (<button className="card-image__cta" onClick={() => { navigate(`${project_url}`); }}>{ctaLabel}</button>);

    return (
        <article className="card-image">
            <figure className="card-image__media">
                <a href={externalLink ? project_url : `${location.origin}${project_url}`} target={externalLink ? "_blank" : undefined} rel="noopener noreferrer">
                    <img src={image_Url} alt={project_Name} />
                </a>
                {cta}
                <figcaption className="card-image__caption">{project_Name}</figcaption>
            </figure>
            <p className="card-image__body">{description}</p>
        </article>
    );
}
